import { ChangeDetectionStrategy, Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { RegexConstants, RegexValidator } from '../../core/utility/lgv-regex-validator';

@Component({
    selector: 'lus-user-invite-modal',
    templateUrl: './user-invite-modal.component.html',
    styleUrls: ['./user-invite-modal.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserInviteModalComponent implements OnInit {
    userInfoForm: UntypedFormGroup;
    constructor(public dialogRef: MatDialogRef<UserInviteModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: any,
        private fb: UntypedFormBuilder,) { }

    ngOnInit(): void {
        this.userInfoForm = this.fb.group({
            firstName: [null, [Validators.required]],
            lastName: [null, [Validators.required]],
            email: [null, [Validators.required, RegexValidator(RegexConstants.EMAIL)]],
        })
    }

    onCancel(): void {
        this.dialogRef.close({ action: false });
    }

    onSend() {
        this.dialogRef.close(
            {
                action: true,
                formValue: this.userInfoForm.getRawValue()
            }
        );
    }

}
